import { render } from "./PageListarSetor.vue?vue&type=template&id=07986335"
import script from "./PageListarSetor.vue?vue&type=script&lang=js"
export * from "./PageListarSetor.vue?vue&type=script&lang=js"

import "./PageListarSetor.vue?vue&type=style&index=0&id=07986335&lang=css"
/* custom blocks */
import block0 from "./PageListarSetor.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__